import { DataFetcher } from "components/DataFetcher";
import Pod from "components/Pod/Pod";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getFetchOptions } from "utils/fetch";
import QuickSearch from "../QuickSearch";
import SearchResultsList from "./components/SearchResultsList";
import AiChatTranscriptPanel from "../../AiOverview/UI/AiChatTranscriptPanel";

const SearchResults = () => {
	const { state: searchTerm } = useLocation();
	const [fetchData, setFetchData] = useState({});
	const [searchResults, setSearchResults] = useState([]);
	const [hasAiSearch, setHasAiSearch] = useState(false);

	useEffect(() => {
		const value = sessionStorage.getItem("hasTeamsOffer");
		setHasAiSearch(value === "true");
	}, []);

	useEffect(() => {
		const options = getFetchOptions({
			method: "POST",
			body: searchTerm
		});
		setFetchData({ url: "api/Search/", options: options });

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchTerm, hasAiSearch]);

	return (
		<div className="grid-two-col gutters">	
			<Pod title="Search Results">
				<div className="searchResultsList-searchterm">
					<h2>Search Term: {searchTerm}</h2>
				</div>
				{(hasAiSearch) && (
					<AiChatTranscriptPanel
						enabled={hasAiSearch}
						initialQuestion={searchTerm}
					/>
				)}
				<SearchResultsList searchTerm={searchTerm} searchResults={searchResults}></SearchResultsList>
			</Pod>
			<Pod title="Search" mobileOrder={2} sticky>
				<QuickSearch />
			</Pod>
			<DataFetcher fetchData={fetchData} setData={setSearchResults}></DataFetcher>
		</div>
	);
};

export default SearchResults;